(function ($) {
  Drupal.behaviors.desire_shades_carousel = {
    attach: function (context) {
      $('#desire_mod4', context).once(function (idx, element) {
        var options = {
          infinite: true,
          pagination: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 700,
          easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
          prevButtonSelector: '.js-previous',
          nextButtonSelector: '.js-next',
          slidesSelector: '.carousel-slide',
          bodySelector: '.carousel__body',
          trackSelector: '.carousel__track',
          carouselActiveClass: 'carousel--active',
          buttonDisabledClass: 'disabled'
        };
        // elements, for ease of access
        var $container = $(element),
          $carouselBody = $container.find(options.bodySelector),
          $slides = $container.find(options.slidesSelector),
          $allSlides = $(),
          $track = $container.find(options.trackSelector),
          $prevButton = $container.find(options.prevButtonSelector),
          $nextButton = $container.find(options.nextButtonSelector);
        // initial values
        var trackWidth = 0,
          trackPosition = 0,
          trackOffset = 0,
          currentSlide = 0,
          slideWidth = 0,
          slideOuterWidth = 0,
          shadeWidth = 0,
          currentColumn = 0, // Desire Boutique Specific (0 - left col, 1 - middle col, 2 - right col)
          transition = ['transform', options.speed + 'ms', options.easing].join(' '), // <property> <duration> <timing-function>
          animating = false,
          centerMode = false,
          unwrapped = false,
          initial = true,
          hasAnimatedIn = false,
          moduleWilFade = $container.data('scrollmagic-offset') === 1,
          moduleBackground = $container.data('bg-color') || 'dark',
          smOffset = $container.data('scrollmagic-offset') || 0,
          smScene,
          smController,
          mppTarget,
          dataSkuBaseId,
          $thisparent = $container.parent(),
          $shadeItemElem;

        if ($thisparent.parents('.node-elc-nodeblock').length) {
          mppTarget = $container.parents().eq(3).prev('.mpp');
        } else {
          mppTarget = $container.parent().prev('.mpp');
        }

        var targetDetach = mppTarget.find('.product-brief'),
          targetAttach = $container.find('.js-desire-mod4__qs'),
          targetQSOpen_1 = mppTarget.find(
            'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
          ),
          targetQSClose_1 = mppTarget.find(
            'a.product-brief__button-quickshop--close.js-quickshop-hide'
          );

        // do we need to activate carousel? if we do, we add a class that indicates it
        function activeCarouselCheck() {
          if ($slides.length > options.slidesToShow || $(window).width() <= 768) {
            $container.addClass(options.carouselActiveClass);
          }
        }

        // if there are only 3 slides then no need for carousel func
        function checkSlideNum() {
          if ($slides.length <= options.slidesToShow && $(window).width() > 768) {
            $prevButton.add($nextButton).addClass('carousel_inactive');
          }
        }

        /**
         * Module initialization
         * TODO prepareDots function to build the pagination
         */
        function init() {
          activeCarouselCheck();
          checkSlideNum();
          initCarousel();
          initModuleAnimation();

          initial = false;
        }

        /**
         * Unwraps the slides and makes them direct children of the track
         */
        function unwrapSlides() {
          if (!unwrapped) {
            $track.html($slides);
            unwrapped = true;
          }
        }

        /**
         * Initialize the carousel functionality
         */
        function initCarousel() {
          unwrapSlides();
          prepareInfinite();
          updateSlidesWidth();
          prepareValues();
          prepareTrack();
          updateButtonsState();
          updateCopy();
          bindEvents();
        }

        /**
         * Animate in the title
         */
        function animateInTitle() {
          if (!hasAnimatedIn) {
            $container.find('.js-desire_mod4__texture').animate(
              {
                marginLeft: '0%'
              },
              800,
              'easeOutQuad'
            );
          }
        }

        /**
         * Animate in the body
         */
        function animateInBody() {
          if (!hasAnimatedIn) {
            hasAnimatedIn = true;
            $carouselBody.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad',
              function () {
                $prevButton.add($nextButton).addClass('visible');
              }
            );
          }
        }

        /**
         * Specific to Desire Boutique Shades Carousel
         * - applies black background to a container above the module
         * - makes the shades visible in all slides except the first (so they fade later)
         * - hides the module (if moduleWillFade is true)
         * - prepares ScrollMagic to trigger the animation of the carousel and shades fade-in
         */
        function initModuleAnimation() {
          if (initial) {
            $container
              .parent()
              .parent()
              .addClass('desire__module-' + moduleBackground + '-bg');

            // the 1st slide shades remain hidden, but we show all others
            $allSlides
              .not('.original-first')
              .find('.desire-shades-carousel__shade')
              .addClass('visible');

            // prepare scroll magic and trigger the 1st slide shades to fade in
            if (moduleWilFade) {
              $carouselBody.addClass('hideModules');
            }

            smController = new ScrollMagic.Controller();
            smScene = new ScrollMagic.Scene({
              triggerElement: '#desire_mod4',
              offset: smOffset
            })
              .addTo(smController)
              .on('start', function (e) {
                animateInTitle();
                animateInBody();
                Drupal.behaviors.desire_shades_carousel_slide.showChildren(
                  $allSlides.eq(currentSlide),
                  1250
                );
              });
          }
        }

        /**
         * Gather initial widths and other values
         */
        function prepareValues() {
          // slideWidth - inner width of the slide, without padding or margin
          slideWidth = $allSlides.filter(':visible').first().width();

          // slideOuterWidth - full width of the slide with padding and margin
          slideOuterWidth = $allSlides.filter(':visible').first().outerWidth(true);

          // Desire Boutique Shade specific
          shadeWidth = $allSlides
            .filter(':visible')
            .first()
            .find('.desire-shades-carousel__shade')
            .outerWidth(true);

          // reset trackPosition
          trackPosition = 0;

          // trackWidth - the total width of the track so it accommodates all slides
          trackWidth = Math.ceil(slideOuterWidth) * $allSlides.length;

          // centerMode - if there's not enough space for slidesToShow we center the current slide
          // trackOffset - space to have on the sides so the current slide is centered
          if ($carouselBody.width() < options.slidesToShow * slideWidth) {
            trackOffset = ($carouselBody.width() - slideWidth) / 2;
            centerMode = true;
          } else {
            trackOffset = 0;
            centerMode = false;
          }
        }

        /**
         * Prepare track to contain all slides by increaing it's width and it's initial position if required
         */
        function prepareTrack() {
          $track.css('width', trackWidth);

          if (options.infinite === true && initial === true) {
            currentSlide = options.slidesToShow;
          }

          goToCurrentSlide(false);
        }

        /**
         * Add the css transition to the track style property so it animates when transform:translate changes
         */
        function applyTransition() {
          animating = true;
          $track.css('transition', transition);
        }

        /**
         * Remove the css transition from the track style property
         */
        function removeTransition() {
          animating = false;
          $track.css('transition', '');
        }

        /**
         * Clones the same number of slides in options.slidesToShow from each end of the track and places
         * them in the opposite side so we can achieve an infinite scroll by mimicking a typewriter
         */
        function prepareInfinite() {
          if (options.infinite && initial === true) {
            // slides from start to end
            $slides
              .slice(0, options.slidesToShow)
              .clone(true)
              .addClass('cloned-slide')
              .appendTo($track);

            // slides from end to start
            $slides
              .slice(-options.slidesToShow)
              .clone(true)
              .addClass('cloned-slide')
              .prependTo($track);

            // if we clone we mark the original first and last slides
            $slides.first().addClass('original-first').end().last().addClass('original-last');
          }

          // update $allSlides to include cloned slides if they exist
          $allSlides = $container.find(options.slidesSelector);
        }

        /**
         * Checks if the track can be slided left
         * @returns {boolean}
         */
        function canSlideLeft() {
          return currentSlide < $allSlides.length - options.slidesToShow;
        }

        /**
         * Checks if the track can be slided right
         * @returns {boolean}
         */
        function canSlideRight() {
          return currentSlide > 0;
        }

        /**
         * Actions to be performed after sliding (remove transition, adjust position, update copy and buttons state)
         */
        function afterSlide() {
          removeTransition();
          adjustPosition();
          updateCopy();
          updateButtonsState();
        }

        /**
         * Carousel only has 1 active slide when in centerMode, here we switch the class over to the new one
         * can be used to control visible text for only 1 slide using css
         */
        function updateCopy() {
          if (centerMode) {
            $allSlides.removeClass('current').eq(currentSlide).addClass('current');
          }
        }

        /**
         * If this is an infinite carousel, then when we are at the beginning or end of the track, we jump
         * to the matching slides on the other end, achieving a similar typewriter effect (Ding-ziiiiiiiiiiiiiiiip)
         */
        function adjustPosition() {
          if (options.infinite) {
            var adjustedSlide = false;

            // if we're at the beginning of the slides, adjust to real non-cloned slide
            if (
              (centerMode && currentSlide === 0 && currentColumn === 1) ||
              (!centerMode && currentSlide === 0)
            ) {
              adjustedSlide = $allSlides.length - options.slidesToShow - 1;
            }

            // if we're at the end of slides, adjust to the non-cloned equivalent
            if (currentSlide === $allSlides.length - options.slidesToShow) {
              adjustedSlide = options.slidesToShow;
            }

            // apply the new position if we need to adjust
            if (adjustedSlide !== false && adjustedSlide !== currentSlide) {
              currentSlide = adjustedSlide;
              goToCurrentSlide(false);
            }

            updateCopy();
          }
        }

        /**
         * Updates the Previous and Next button state by adding the options.buttonDisabledClass if we can't scroll to
         * the respective side
         */
        function updateButtonsState() {
          if (!options.infinite) {
            $prevButton.toggleClass(options.buttonDisabledClass, !canSlideRight());
            $nextButton.toggleClass(options.buttonDisabledClass, !canSlideLeft());
          }
        }

        /**
         * Event handler for Previous button click
         */
        function onPrevButtonClick() {
          if ($(this).hasClass('disabled')) {
            return;
          }
          slideRight();
        }

        /**
         * Event handler for Next button click
         */
        function onNextButtonClick() {
          if ($(this).hasClass('disabled')) {
            return;
          }
          slideLeft();
        }

        /**
         * Slides the track to the left if it's not currently animating
         */
        function slideLeft() {
          if (animating) {
            return;
          }

          if (centerMode && currentColumn < 2) {
            currentColumn = currentColumn + 1;
          } else {
            currentSlide = canSlideLeft() ? currentSlide + options.slidesToScroll : currentSlide;
            currentColumn = 0;
          }

          goToCurrentSlide();
        }

        /**
         * Slides the track to the left if it's not currently animating
         */
        function slideRight() {
          if (animating) {
            return;
          }

          if (centerMode && currentColumn > 0) {
            currentColumn = currentColumn - 1;
          } else {
            currentSlide = canSlideRight() ? currentSlide - options.slidesToScroll : currentSlide;
            currentColumn = 2;
          }

          goToCurrentSlide();
        }

        /**
         * Sets the track position by setting a negative transform:translate css value
         * @param {int} position - The pixel value to move the track
         */
        function goTo(position) {
          trackPosition = -(position - trackOffset);
          $track.css('transform', 'translate(' + trackPosition + 'px)');
        }

        /**
         * Change the position of the track but animating the transition
         * @param {int} position - The new track position
         */
        function changeSlide(position) {
          applyTransition();
          goTo(position);
          setTimeout(afterSlide, options.speed); // delay the call of the callback by the time the animation lasts
        }

        /**
         * Moves the track to the slide index tracked in currentSlide
         * @param {boolean} [animate=true] - Should the transition be animated?
         */
        function goToCurrentSlide(animate) {
          var position = $allSlides.eq(currentSlide).position().left;

          animate = animate !== false; // defaults to true

          if (centerMode) {
            position += shadeWidth * currentColumn;
          }

          if (animate) {
            changeSlide(position);
          } else {
            goTo(position);
          }
        }

        // Append Quickshop on Mobile
        function appendMobQuickshop() {
          if ($(window).width() <= 768) {
            mppTarget.addClass('mpp_qs_detached');
            mppTarget.detach().insertAfter($thisparent);
            targetQSOpen_1.addClass('shop_now_dark shop_now_centered');
            targetQSClose_1.addClass('shop_now_light shop_now_white shop_now_centered');
            // Need to wait for mpp to load.
            $(window).on('load', function () {
              targetDetach.detach().insertAfter(targetAttach);
              mppTarget.detach().appendTo($container);
            });
          }
        }
        appendMobQuickshop();

        // Event handler for Shade QS button click
        function onQSButtonClick(e) {
          dataSkuBaseId = $(this).attr('data-sku-base-id');
          $shadeItemElem = $('#desire_mod4 .js-quickshop-show').not('.hidden');
          if (!dataSkuBaseId) {
            dataSkuBaseId = 0;
          }
          if ($(window).width() <= 768) {
            e.preventDefault();
            $shadeItemElem.trigger('click');
            // Need to wait for li items to populate.
            setTimeout(function () {
              $container
                .find('.mpp_qs_detached li a.swatch[data-sku-base-id="' + dataSkuBaseId + '"]')
                .trigger('click');
            }, 350);
          } else {
            // Need to wait for modal to populate.
            setTimeout(function () {
              $(
                '.quickshop__description .quickshop__tabs .quickshop__tab-container .quickshop__tab--shade ul li a.swatch[data-sku-base-id="' +
                  dataSkuBaseId +
                  '"]'
              ).trigger('click');
            }, 350);
          }
        }

        /**
         * Attach events
         */
        function bindEvents() {
          $prevButton.on('click', onPrevButtonClick);
          $nextButton.on('click', onNextButtonClick);
          $container.find('.js-desire-shades-carousel__qs').on('click', onQSButtonClick);
          $(window).one('resize', _.debounce(onResize, 100));

          // Handle swipe of carousel on mobile
          if ((window.innerWidth || $(window).width()) <= 768) {
            bindSwipe();
          }
        }

        /**
         * Remove events
         */
        function unbindEvents() {
          $prevButton.off('click');
          $nextButton.off('click');

          unbindSwipe();
        }

        /**
         * Specific to Desire Shades Carousel. We need to set a width to each slide that matches the size of container
         */
        function updateSlidesWidth() {
          $allSlides.width($carouselBody.width());
        }

        /**
         * Does some cleanup, removes cloned slides and events
         */
        function destroy() {
          // $container.find('.cloned-slide').remove();
          unbindEvents();
        }

        /**
         * Event handler for the window resize event
         * TODO only do the onResize if the width difference requires it (when it actually changes or when it's less than our max-width (1366px)
         */
        function onResize() {
          destroy();
          updateSlidesWidth();
          init();
        }

        /**
         * Attaches events for the swiping on mobile devices
         */
        function bindSwipe() {
          $track.swiperight(function () {
            $prevButton.trigger('click');
          });
          $track.swipeleft(function () {
            $nextButton.trigger('click');
          });
        }

        /**
         * Removes the swipe events
         */
        function unbindSwipe() {
          $track.unbind('swiperight swipeleft');
        }

        init();
      });
    }
  };
})(jQuery);
